<template>
  <div class="layout">
    <Header class="Header" />
 
    <Sidebar>
      <router-view class="router-view" />
    </Sidebar>
  
  </div>
</template>

<script>
import Header from "@/layout/Header.vue";
import Sidebar from "@/layout/Sidebar.vue";

export default {
  components: {
    Header,
    Sidebar,
  },  
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.layout{
  background-color: #f0f2f4;
  height: 100vh;
  overflow: hidden;
}
</style>